import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

// Inicializar Google Analytics (apenas uma vez)
ReactGA.initialize("UA-4822135-11", {
  debug: process.env["REACT_APP_GADEBUG"] === "development",
  titleCase: false,
});

interface GAOptions {
  [key: string]: string | number | boolean | undefined;
}

const GATracker = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  options: GAOptions = {}
) => {
  const trackPage = (page: string) => {
    ReactGA.set({
      page,
      ...options,
    });
    ReactGA.pageview(page);
  };

  const TrackedComponent: React.FC<P> = props => {
    const location = useLocation();

    useEffect(() => {
      const page = location.pathname + location.search;
      trackPage(page);
    }, [location.pathname, location.search]);

    return <WrappedComponent {...props} />;
  };

  return TrackedComponent;
};

export default GATracker;
